import { Outlet } from "react-router-dom"

import { PageHeader } from "@/components/PageHeader"
import { SeccionTabs } from "@/components/SeccionTabs"
import { t } from "@/lib/i18n"

const TABS = [
  // SOCIEDADES va primero: es el maestro del que cuelgan los demas, y es donde
  // se declara el regimen tributario —el dato que el onboarding pide y que
  // hasta el 2026-09-28 no habia forma de dar.
  { to: "sociedades", label: "Sociedades" },
  // EL PLAN DEL P&L va segundo, pegado a Sociedades, porque es el otro maestro
  // del que cuelga todo: los comprobantes se clasifican contra el, y sin el no
  // hay estado de resultados de gestion. No es normativo —no lo exige ningun
  // fisco— y por eso lo edita el cliente.
  { to: "plan-pl", label: "Plan del P&L" },
  // LOS PERIODOS van junto a Sociedades y al Plan porque son la tercera pieza
  // sin la cual no se puede asentar nada: un comprobante cuyo periodo no esta
  // abierto se clasifica y no llega al libro.
  { to: "periodos", label: "Periodos" },
  { to: "clientes", label: "Clientes" },
  { to: "proveedores", label: "Proveedores" },
  { to: "contratos", label: "Contratos" },
  { to: "personas", label: "Personas" },
  { to: "centros-costo", label: "Centros de costo" },
  /*
    AQUÍ HABÍA «POLÍTICAS DE COBRANZA Y PAGO», y se quitó. El formulario
    guardaba la cadencia como una lista y el escalamiento como `{dia}`, y el
    motor de cobranza lee OTRAS claves (`avisos_previos`, `escalar_a_los_dias`…):
    lo que se editaba no cambiaba ningún aviso, y la tolerancia y el descuento
    no los leía nadie. Las políticas de pago no las usa ningún módulo. Una
    pantalla que parece configurar y no configura es peor que ninguna. La
    cadencia vigente se ve en Finanzas › Cobranzas.
  */
  { to: "reglas", label: "Reglas de tratamiento" },
  // MOVIMIENTOS BANCARIOS: el armado de la caja. Cesar, 2026-10-04: «en el
  // maestro ponla también para poder ver todos los movimientos y poder editar
  // y comentar cuáles sin considerar y cómo, en qué parte».
  { to: "movimientos-bancarios", label: "Movimientos bancarios" },
  // CARGA POR ARCHIVO al final y no al principio: quien llega aqui por primera
  // vez tiene que ver antes QUE maestros existen. Pero es la pestaña que mas
  // desbloquea —cargar cuarenta personas a mano es exactamente lo que hace que
  // nadie las cargue—, asi que el onboarding enlaza directo a ella.
  { to: "carga", label: "Carga por archivo" },
]

export function MastersLayout() {
  return (
    <div className="space-y-3">
      <PageHeader
        eyebrow="Configuracion del negocio"
        title={t("Maestros")}
        description={t("Todo esto lo configura el usuario, no un ingeniero. Cada cambio queda versionado con autor, fecha y motivo; la proyeccion se recalcula y los periodos cerrados no se tocan.")}
      />

      <SeccionTabs tabs={TABS} ariaLabel="Maestros" />

      <Outlet />
    </div>
  )
}
